import { AllocationStatus } from "@flexidao/dto";

export const formatAllocationStatus = (allocationStatus: AllocationStatus): string => {
    switch (allocationStatus) {
        case AllocationStatus.Allocated:
            return "Linked to contracts";
        case AllocationStatus.Unallocated:
            return "Not linked to contracts";
    }
};
